import { BoxProps } from '@chakra-ui/react';
import React from 'react';

import { CmBox } from '..';

export const CmScrollBox: React.FC<BoxProps> = ({
  children,
  pb = 5,
  ...rest
}) => {
  return (
    <CmBox overflowY="scroll" {...{ pb, ...rest }}>
      {children}
    </CmBox>
  );
};
